import { KatAppLayout, KatButton, KatNavigation, KatPopover } from '@amzn/katal-react';
import React, { useState, Suspense } from 'react';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { applicationNavigationRoutes } from 'src/core/hooks/useNavigationRoutes';
import { LoadingState } from 'src/features/components/granularSLA/LoadingState';
import { useUser } from 'src/utils/UserContext';
import { DEFAULT_LOCALE } from '../constants';
import { Link, Outlet } from 'react-router-dom';
import arbManifest from 'translations/arbManifest';
import { resolveBundleUrlWithFallbacks } from '../helpers';
import { isAFTXDomain } from 'src/utils/Auth';
import { getEnv } from 'src/utils/Environment';
import { ENV } from 'src/core/config/APIConstants';

const mbmOptions = {
    arbManifest,
    defaultLocalizationContext: new LocalizationContextBuilder().withLocale( DEFAULT_LOCALE ).withDefaultLocale( DEFAULT_LOCALE ).build(),
    resolveBundleUrl: (
        resourcePackPath: string | undefined,
        locale: string,
        bundle: string,
    ) => resolveBundleUrlWithFallbacks( resourcePackPath, locale, bundle ),
};

import ErrorBoundary from './ErrorBoundary';
import { memo } from 'react';

const App = memo(() =>
{

    const { granularSLALanding, granularSLARoute, bulkGranularSLARoute, r2fThresholdRoute, bulkR2fThresholdRoute, coraRoute } = applicationNavigationRoutes();
    const { user } = useUser();
    const [ isHelpOpen, setIsHelpOpen ] = useState( false );

    const permissionsAvailable = () =>
    {
        return <ul style={{ listStyle: 'none', padding: 0 }}>
            {user?.isAuthorizedForSLAOverrides && (
                <li style={{ marginBottom: '0.5rem' }}>
                    SLA Override Access
                </li>
            )}
            {user?.isDevAdmin && (
                <li style={{ marginBottom: '0.5rem' }}>
                    Developer Access
                </li>
            )}
        </ul>;
    };


    return (
            <KatAppLayout>
            <div className={'navigationHeader'}>
                <KatNavigation slot='top' mode='horizontal'>
                    <div className={'nav-container'}>
                        <div className={'nav-links'}>
                            <Link to='/' className={'nav-item'}>Home</Link>
                            <Link to={granularSLALanding} className={'nav-item'}>SLA</Link>
                            <Link to={bulkGranularSLARoute} className={'nav-item'}>Bulk SLA</Link>
                            <Link to={r2fThresholdRoute} className={'nav-item'}>TRB Thresholds</Link>
                            <Link to={bulkR2fThresholdRoute} className={'nav-item'}>Bulk TRB Thresholds</Link>
                            {(isAFTXDomain() || getEnv() !== ENV.PRODUCTION) && (
                                <Link to={coraRoute} className={'nav-item'}>CORA</Link>
                            )}
                        </div>

                    </div>
                </KatNavigation>
                <div className={'profile-button'}>
                    <KatPopover katAriaBehavior='tooltip'
                                position='bottom'
                                triggerType='click'>
                        <KatButton
                            slot='trigger'
                            variant='secondary'>
                            Welcome {user?.login}
                        </KatButton>
                        <h4>Permissions Granted:</h4>
                        {permissionsAvailable()}
                        <h4>Support Resources</h4>
                        <ul>
                            <li>
                                <KatButton variant='link' onClick={() => window.open( '/support/new' )}>
                                    Create New Ticket
                                </KatButton>
                            </li>
                            <li>
                                <KatButton variant='link' onClick={() => window.open( '/support/knowledge-base' )}>
                                    Knowledge Base
                                </KatButton>
                            </li>
                        </ul>
                    </KatPopover>
                </div>
            </div>
            <div className={'main-content'}>
                    <Outlet />
            </div>

            <footer slot='bottom'></footer>
        </KatAppLayout>
    );
});

export default App;
